var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButton',{staticClass:"button-round",attrs:{"buttonClass":"button-warning"},on:{"click":function($event){return _vm.remove(_vm.prefix)}}},[_vm._v(" Unwatch ")])}
var staticRenderFns = []

export { render, staticRenderFns }